<div class="feedback-nfce" [ngClass]="'tipo-' + tipo">
  <div class="feedback-nfce__hero">
    <div class="feedback-nfce__icone">
      <i class="fa" [ngClass]="icone"></i>
    </div>
    <div class="feedback-nfce__cabecalho">
      <h3>{{ tituloExibicao }}</h3>
      <p *ngIf="subtituloExibicao">{{ subtituloExibicao }}</p>
    </div>
  </div>

  <div class="feedback-nfce__produto" *ngIf="produtoNormalizado">
    <i class="fa fa-tag"></i>
    <span>{{ produtoNormalizado }}</span>
  </div>

  <div class="feedback-nfce__mensagem-geral" *ngIf="mensagemExibicao && !listaPendenciasNormalizada.length">
    {{ mensagemExibicao }}
  </div>

  <div class="feedback-nfce__lista-pendencias" *ngIf="listaPendenciasNormalizada.length">
    <div [ngClass]="item.classe" *ngFor="let item of listaPendenciasNormalizada">
      <i class="fa" [ngClass]="item.icone"></i>
      <div class="item-texto">
        <strong>{{ item.titulo }}</strong>
        <p>{{ item.descricao }}</p>
      </div>
    </div>
  </div>

  <div class="feedback-nfce__acoes">
    <button type="button" class="btn btn-secundario" (click)="fechar()">
      {{ tituloBotao }}
    </button>
  </div>
</div>
